import axios from 'axios';
import { backendURL } from './consts';

export const getOrgLocations = async (token) => {
  const res = await axios.get(
    `${backendURL}/organization/locations`,
    {
      headers:{
        token: `bearer ${token}`
      }
    }
  )
  return res.data;
}